import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Chat from './pages/Chat'
import Login from './pages/Login'
import Register from './pages/Register'
import SetAvatar from './components/setAvatar'
import PageNotFound from './pages/PageNotFound'
import SetEmail from './pages/SetEmail'
import Landing from "./pages/Landing"
import ResetPass from "./pages/ResetPass"
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/setAvatar" element={<SetAvatar />} />
        <Route path="/SetEmail" element={<SetEmail />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/resetpassword/*" element={<ResetPass />} />
        
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
